import type { ReactNode } from 'react';
import { Col, Row, type RowProperties, Space } from 'ui';

type P = {
  gutter?: RowProperties['gutter'];
  left: ReactNode;
  right?: ReactNode;
  top?: ReactNode;
};

const EventButtonsListLayout = ({ gutter, left, right, top }: P) => (
  <Row gutter={gutter}>
    {top ? <Col span={24}>{top}</Col> : null}
    <Col span={24}>
      <Space size="xs">
        {left}
        {right}
      </Space>
    </Col>
  </Row>
);

export default EventButtonsListLayout;
